var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgCube = function SvgCube(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.143 0h-.285L.5 4.445v8.02L8.828 18h.344l8.328-5.536v-8.02L9.142 0zm6.591 4.781-2.71 1.441-3.01-1.6 2.709-1.442zm-6.733-3.58 2.71 1.44L9 4.082l-2.71-1.44L9.001 1.2zM5.278 3.18l2.71 1.44-3.011 1.601-2.71-1.441zM3.991 13.428l-2.357-1.567V9.136l2.357 1.462zm0-3.95L1.634 8.016V5.72l2.357 1.253zm4.443 6.903-3.487-2.317v-2.873l3.487 2.163zm0-4.146-3.487-2.163v-2.59l3.487 1.854zm.567-3.874L5.99 6.76 9 5.16l3.011 1.6-3.01 1.6zm4.054 5.703-3.487 2.317v-3.028l3.487-2.163zm0-3.992-3.487 2.163v-2.9l3.487-1.853zm3.313 1.79-2.356 1.566v-2.831l2.356-1.462v2.729zm0-3.846L14.012 9.48V6.975l2.356-1.254v2.297z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCube);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;